module.exports = __webpack_public_path__ + "img/18 RedteaGO Global eSIM Plan _m.71976703.png";